import React from "react";

const DeleteModal = ({ handleDelete, closeModal }) => {
  return (
    <div class="fixed top-0 left-0 right-0 bottom-0 z-50 pt-[200px] w-full flex justify-center p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full">
      <div class="relative w-full max-w-md max-h-full">
        <div class="relative rounded-lg shadow bg-gray-600">
          <button
            onClick={() => closeModal(false)}
            type="button"
            class="absolute top-3 right-2.5 text-gray-300 bg-transparent rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center hover:text-white"
            data-modal-hide="authentication-modal"
          >
            <svg
              class="w-3 h-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
            <span class="sr-only">Close modal</span>
          </button>
          <div class="px-6 py-6 lg:px-8">
            <h3 className="text-center mb-[30px] mt-[20px] text-[20px] font-bold text-white">
              Do You really want to Delete This Item?
            </h3>
            <button
              onClick={handleDelete}
              className="bg-[#fc5555] w-[50%] px-[20px] py-[7px] rounded text-[white] hover:bg-[#fc5555] active:bg-[#9b3232] mx-auto block"
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;
